const VALID_STATUSES = [
  "OPEN",
  "PAID",
  "VOID",
  "REFUNDED",
] as const;
const VALID_ORDER_TYPES = ["DINE_IN", "TAKEAWAY", "DELIVERY"] as const;

export type OrdersListSearch = {
  status?: string;
  orderType?: string;
  shiftId?: string;
  /** ຄົ້ນຫາເລກ order */
  q?: string;
  paymentMethodId?: string;
  page: number;
  sortField: "createdAt" | "grandTotal";
  sortOrder: "asc" | "desc";
};

/**
 * ກວດ search params ສຳລັບໜ້າລາຍການ order — ໃຊ້ກັບ TanStack Router validateSearch
 */
export function parseOrdersListSearch(
  raw: Record<string, unknown>,
): OrdersListSearch {
  const s = typeof raw.status === "string" ? raw.status.trim() : "";
  const status =
    s &&
    (VALID_STATUSES as readonly string[]).includes(s)
      ? s
      : undefined;

  const ot = typeof raw.orderType === "string" ? raw.orderType.trim() : "";
  const orderType =
    ot && (VALID_ORDER_TYPES as readonly string[]).includes(ot)
      ? ot
      : undefined;

  const shiftId =
    typeof raw.shiftId === "string" && raw.shiftId.trim()
      ? raw.shiftId.trim()
      : undefined;

  const qRaw = typeof raw.q === "string" ? raw.q.trim() : "";
  const q = qRaw.length > 0 ? qRaw : undefined;

  const pm =
    typeof raw.paymentMethodId === "string"
      ? raw.paymentMethodId.trim()
      : "";
  const paymentMethodId = pm.length > 0 ? pm : undefined;

  const pageRaw = Number(raw.page);
  const page =
    Number.isFinite(pageRaw) && pageRaw >= 1 ? Math.floor(pageRaw) : 1;

  const sortField =
    raw.sortField === "grandTotal" ? "grandTotal" : "createdAt";
  const sortOrder = raw.sortOrder === "asc" ? "asc" : "desc";

  return {
    status,
    orderType,
    shiftId,
    q,
    paymentMethodId,
    page,
    sortField,
    sortOrder,
  };
}
